import React from 'react';
import { IconProps } from '.';

const SvgBoxHome = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M2 5.022A3.016 3.016 0 0 1 5.01 2h13.98A3.016 3.016 0 0 1 22 5.022v13.956A3.016 3.016 0 0 1 18.99 22H5.01A3.016 3.016 0 0 1 2 18.978V5.022Z'
      />
      <path fill='#fff' d='m12 6.375-6.25 6.25h2.5v5h2.916v-3.75h1.667v3.75h2.917v-5h2.5L12 6.375Z' />
    </svg>
  );
};

export default SvgBoxHome;
